import { render, staticRenderFns } from "./SalesDelivery.vue?vue&type=template&id=933f37d2"
import script from "./SalesDelivery.vue?vue&type=script&lang=ts"
export * from "./SalesDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports